
const tabs = document.querySelectorAll(".section-faq .faq__tabs .tab");
const faqGroups = document.querySelectorAll(".section-faq .faq-item");

tabs.forEach(tab => {
  tab.addEventListener("click", function() {
    let target = this.getAttribute("data-tab");
    tabs.forEach(t => t.classList.remove("active-tab"));
    this.classList.add("active-tab");
    faqGroups.forEach(group => {
      if (group.classList.contains(target)) {
        group.style.display = "block";
      } else {
        group.style.display = "none";
      }
    });
  });
});
document.querySelectorAll(".section-faq .faq__tabs .tab")[0]?.click();

$(document).ready(function(){
  if ($(window).width() < 768) {
    $('.collection-row.row-three').slick({
      dots: false,
      arrows: false,
      infinite: false,
      slidesToShow: 1.5,
      slidesToScroll: 1
    });
   setInterval(() => {
    const $cr = $('.cart-recommendations .list-unstyled');
    if ($cr.length && !$cr.hasClass('slick-initialized')) {
      $cr.slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  }, 300);
  }
   $('.custom_cross_sell_pdp .cross_sell_pdp').slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  //  $('.main_custom_product__grid').slick({
  //     dots: true,
  //     arrows: true,
  //     infinite: false,
  //     slidesToShow: 4,
  //     slidesToScroll: 1
  //   });
});

// custom collection filter
document.addEventListener("DOMContentLoaded", function () {
  const products = document.querySelectorAll(".custom_product__grid");
function setupFilter(filterSelector, dataAttr, otherFilterSelector) {
  const filterContainer = document.querySelector(filterSelector);
  const otherFilterContainer = document.querySelector(otherFilterSelector);
  if (!filterContainer) return;

  const mainButton = filterContainer.querySelector(".filter_values");
  const optionsContainer = filterContainer.querySelector(".main_filter_values");
  const options = optionsContainer.querySelectorAll(".filter_values");
  const defaultText = mainButton.childNodes[0].textContent.trim();

  mainButton.addEventListener("click", function () {
    optionsContainer.classList.toggle("active");
    const tabs = document.querySelectorAll('.tabs-navigation-item');
    tabs.forEach(tab => tab.classList.remove("active"));
  });

  document.addEventListener("click", function (e) {
    if (!filterContainer.contains(e.target)) {
      optionsContainer.classList.remove("active");
    }
  });

  options.forEach(option => {
    option.addEventListener("click", function () {
      const selectedValue = this.textContent.trim();
      mainButton.childNodes[0].textContent = selectedValue + " ";
      optionsContainer.classList.add("active");
      const tabs = document.querySelectorAll('.tabs-navigation-item');
      tabs.forEach(tab => tab.classList.remove("active"));

      if (otherFilterContainer) {
        const otherMainButton = otherFilterContainer.querySelector(".filter_values");
        const otherDefaultText = otherMainButton.getAttribute("data-default-text");
        if (otherDefaultText) {
          otherMainButton.childNodes[0].textContent = otherDefaultText + " ";
        }
      }

      products.forEach(product => {
        const productValue = product.getAttribute(dataAttr)?.trim();
        if (productValue === selectedValue) {
          product.style.display = "block";
        } else {
          product.style.display = "none";
        }
      });
    });
  });

  mainButton.setAttribute("data-default-text", defaultText);
}

// Call setup
setupFilter(".custom_collection_filter.age", "data-age", ".custom_collection_filter.theme");
setupFilter(".custom_collection_filter.theme", "data-theme", ".custom_collection_filter.age");


const collectiontabs = document.querySelectorAll(".tabs-navigation-item");
console.log(collectiontabs,"tabstabs");
collectiontabs.forEach(tab => {
tab.addEventListener("click", function () {
 document.querySelectorAll(".custom_product__grid").forEach(product => {
     product.style.display = "block";
     });
});
});
//read more on pdp

const readMoreBtn = document.querySelector('.main__product__description .read_more');
const productDesc = document.querySelector('.product__info-container .product__description');

// Only run this feature if both elements exist
if (readMoreBtn && productDesc) {
  readMoreBtn.addEventListener('click', function () {
    if (productDesc.style.display === 'block') {
      // Collapse
      productDesc.style.display = '-webkit-box';
      readMoreBtn.textContent = 'Lire plus-->';
    } else {
      // Expand
      productDesc.style.display = 'block';
      readMoreBtn.textContent = 'Lire moins-->';
    }
  });
}



// survey
const tabs = document.querySelectorAll('.tabs__products .tab');
const all = document.querySelectorAll('.product-item.all');
const physical = document.querySelectorAll('.product-item.physical');
const digital = document.querySelectorAll('.product-item.digital');
const atcText = document.querySelector('.custom_atc__text');

tabs.forEach((tab, i) => {
  tab.addEventListener('click', () => {
    tabs.forEach(t => t.classList.remove('active'));
    tab.classList.add('active');

    if (i === 0) {
      all.forEach(p => p.style.display = 'flex');
      physical.forEach(p => p.style.display = 'none');
      digital.forEach(d => d.style.display = 'none');
    } else if (i === 1) {
      physical.forEach(p => p.style.display = 'none');
      digital.forEach(d => d.style.display = 'flex');
      all.forEach(a => a.style.display = 'none');
    } else if (i === 2) {
      digital.forEach(d => d.style.display = 'none');
      physical.forEach(p => p.style.display = 'flex');
      all.forEach(a => a.style.display = 'none');
    }
  });
});

tabs[0]?.click();

let totalClicks = 0;
let maxClicks = 0;

const form = document.querySelector('.custom_atc_form');
const optionLabels = document.querySelectorAll('.main_kit_selection div');

function getAllPlusBtns() {
  return document.querySelectorAll('.quantity__button[name="plus"]');
}
function getAllMinusBtns() {
  return document.querySelectorAll('.quantity__button[name="minus"]');
}

function resetQuantities() {
  totalClicks = 0;
  document.querySelectorAll('.quantity__input').forEach(input => input.value = 0);
  form.querySelectorAll('.custom_pack').forEach(el => el.remove());
  getAllPlusBtns().forEach(btn => btn.style.pointerEvents = 'auto');
}

function updateHiddenInputs() {
  form.querySelectorAll('.custom_pack').forEach(el => el.remove());
  let totalPrice = 0;
  document.querySelectorAll('.product-item').forEach((item,i) => {
    const dataId = item.getAttribute('data-id');
    const dataPrice = item.getAttribute('data-price');
    const qty = parseInt(item.querySelector('.quantity__input').value);
    
    if (qty > 0) {
      document.querySelector('.product-form__submit').style.pointerEvents = 'auto';
      document.querySelector('.product-form__buttons').style.cursor = 'pointer';

      const idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = `items[${i}][id]`;
      idInput.value = dataId;
      idInput.classList.add('custom_pack');

      const qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = `items[${i}][quantity]`;
      qtyInput.value = qty;
      qtyInput.classList.add('custom_pack');

      form.appendChild(idInput);
      form.appendChild(qtyInput);

      let priceText = document.querySelector('.price-item.price-item--regular').textContent.trim();
      let numericValue = parseFloat(priceText.replace(/[^\d,.-]/g, '').replace(',', '.'));
      let priceInCents = Math.round(numericValue * 100);
      totalPrice += dataPrice * qty;

      let discount = 0;
      if (maxClicks === 2) discount = 0.10;
      else if (maxClicks === 3) discount = 0.20;
      else if (maxClicks === 4) discount = 0.30;

      let discountedPrice = totalPrice - (totalPrice * discount);
      let totalNetprice = discountedPrice + priceInCents;
      let formattedPrice = new Intl.NumberFormat('de-DE', { 
        style: 'currency', 
        currency: 'EUR' 
      }).format(discountedPrice / 100);

      document.querySelector('.custom_atc__price').textContent = `- ${formattedPrice}`;
    } 
    else {
      document.querySelector('.product-form__submit').style.pointerEvents = 'none';
      document.querySelector('.product-form__buttons').style.cursor = 'not-allowed';
    }
  });
}

function attachButtonEvents() {
  const plusBtns = getAllPlusBtns();
  const minusBtns = getAllMinusBtns();

  plusBtns.forEach(btn => {
    btn.replaceWith(btn.cloneNode(true));
  });
  minusBtns.forEach(btn => {
    btn.replaceWith(btn.cloneNode(true));
  });

  document.querySelectorAll('.quantity__button[name="plus"]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopImmediatePropagation();
      const input = btn.parentElement.querySelector('.quantity__input');
      let value = parseInt(input.value) || 0;

      if (totalClicks < maxClicks) {
        input.value = value + 1;
        totalClicks++;
        updateHiddenInputs();

        let left = maxClicks - totalClicks;
        atcText.textContent = left === 0 ? "Ajouter au panier" : `${left} produits à sélectionner`;

        if (totalClicks >= maxClicks) {
          getAllPlusBtns().forEach(b => b.style.pointerEvents = 'none');
          document.querySelector('.product-form__submit').style.pointerEvents = 'auto';
          document.querySelector('.product-form__buttons').style.cursor = 'pointer';
        }
      }
    });
  });

  document.querySelectorAll('.quantity__button[name="minus"]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopImmediatePropagation();
      const input = btn.parentElement.querySelector('.quantity__input');
      let value = parseInt(input.value) || 0;

      if (value > 0) {
        input.value = value - 1;
        totalClicks--;
        updateHiddenInputs();

        let left = maxClicks - totalClicks;
        atcText.textContent = left === 0 ? "Ajouter au panier" : `${left} produits à sélectionner`;

        if (totalClicks < maxClicks) {
          getAllPlusBtns().forEach(b => b.style.pointerEvents = 'auto');
        }
      }
    });
  });
}

optionLabels.forEach((label, index) => {
  label.addEventListener('click', () => {

    document.querySelector('.product-form__submit').style.pointerEvents = 'none';
    document.querySelector('.product-form__buttons').style.cursor = 'not-allowed';

    optionLabels.forEach(l => l.classList.remove('active'));
    label.classList.add('active');

    resetQuantities();

    if (index === 0) {
      maxClicks = 2;
    }
    if (index === 1) {
      maxClicks = 3;
    }
    if (index === 2) {
      maxClicks = 4;
    }

    atcText.textContent = `${maxClicks} produits à sélectionner`;

    attachButtonEvents();
  });
});

attachButtonEvents();
optionLabels[0]?.click();



//first accordian close by default on PDP
document.querySelectorAll('.product__accordion.accordion details')[0]?.removeAttribute('open')  

});




